import { render } from "./EventDeleteModal.vue?vue&type=template&id=18d23df1&scoped=true&lang=pug"
import script from "./EventDeleteModal.vue?vue&type=script&lang=js"
export * from "./EventDeleteModal.vue?vue&type=script&lang=js"

import "./EventDeleteModal.vue?vue&type=style&index=0&id=18d23df1&scoped=true&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d23df1"]])

export default __exports__